const MEMBERSHIP_TIER_LABELS = {
  free: "Free",
  premium: "Premium",
  pro: "Pro",
  unknown: "Unknown",
};

const KNOWN_MEMBERSHIP_TIERS = new Set(["free", "premium", "pro"]);

export function normalizeMembershipTier(value) {
  if (typeof value !== "string") {
    return "unknown";
  }

  const normalizedValue = value.trim().toLowerCase();
  if (!normalizedValue) {
    return "unknown";
  }

  if (KNOWN_MEMBERSHIP_TIERS.has(normalizedValue)) {
    return normalizedValue;
  }

  return "unknown";
}

export function getMembershipTier(row) {
  if (!row || !Object.prototype.hasOwnProperty.call(row, "membership")) {
    return "free";
  }

  if (typeof row.membership === "undefined") {
    return "free";
  }

  if (
    row.membership === null ||
    typeof row.membership !== "object" ||
    Array.isArray(row.membership)
  ) {
    return "unknown";
  }

  return normalizeMembershipTier(row.membership.tier);
}

export function getMembershipTierDisplay(row) {
  const tier = getMembershipTier(row);

  return {
    tier,
    label: MEMBERSHIP_TIER_LABELS[tier] || MEMBERSHIP_TIER_LABELS.unknown,
  };
}
